// extracted by mini-css-extract-plugin
export default {"card":"SlideCard_card__r83fC","onScale":"SlideCard_onScale__t8xZU","info":"SlideCard_info__onWT3"};